<div class="container-fluid py-4">
    <!-- Header del reporte -->
    <div class="row align-items-center mb-4">
        <div class="col-md-4 text-center text-md-start">
            <img class="logo img-fluid" src="./assets/img/logo.jpeg" alt="Logo Uturunco Studio"
                style="max-height: 80px;">
            <div class="mt-2">
                <h5 class="mb-0 fw-bold">Uturunco Studio</h5>
                <small class="text-muted">Empresa independiente de desarrollo de software</small>
            </div>
        </div>

        <div class="col-md-4 text-center">
            <h3 class="mb-1 fw-bold text-primary">Reporte de Ventas por Detalle</h3>
            <h6 class="text-muted">App Control Stock — Movimientos y ganancias por venta</h6>
        </div>

        <div class="col-md-4 text-center text-md-end">
            <small class="text-muted">
                Resistencia, Chaco<br>
                {{ fecha | date:'dd MM yyyy' }}
            </small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-4">
        <div class="card-body">
            <app-fil-detalle-entrega-2 (filter)="doFound($event)"></app-fil-detalle-entrega-2>
        </div>
    </div>

    <!-- Resultados -->
    <div class="card shadow-sm">
        <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Detalle de ventas y entregas</h5>
            <small class="text-muted" *ngIf="items?.length > 0">
                {{ items.length }} registro{{ items.length !== 1 ? 's' : '' }} encontrado{{ items.length !== 1 ? 's' :
                '' }}
            </small>
        </div>

        <div class="card-body p-0">
            <!-- Loading -->
            <div *ngIf="proccess" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-3 text-muted">Obteniendo detalle de ventas...</p>
            </div>

            <!-- Contenido -->
            <ng-container *ngIf="!proccess">
                <div class="table-responsive">
                    <table id="tblData" class="table table-hover table-bordered mb-0">
                        <thead class="table-dark">
                            <tr>
                                <th>Venta #</th>
                                <th>Fecha</th>
                                <th>Hora</th>
                                <th>Producto</th>
                                <th class="text-center">Cantidad</th>
                                <th class="text-end">Total</th>
                                <th class="text-end">Ganancia</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of items">
                                <td>{{ item.venta?.id || '—' }}</td>
                                <td>{{ item.venta?.created_at | date:'dd-MM-yyyy' }}</td>
                                <td>{{ item.venta?.created_at | date:'HH:mm:ss' }}</td>
                                <td>
                                    <strong>{{ item.mercaderia?.grupo?.nombre || 'Sin grupo' }}</strong><br>
                                    <small class="text-muted">{{ item.mercaderia?.nombre || 'Producto no especificado'
                                        }}</small>
                                </td>
                                <td class="text-center">{{ item.cantidad || 0 }}</td>
                                <td class="text-end fw-bold text-success">
                                    {{ (item.cantidad * item.precio) | currency:'$ ' }}
                                </td>
                                <td class="text-end fw-bold text-primary">
                                    {{ (item.cantidad * item.ganancia) | currency:'$ ' }}
                                </td>
                            </tr>

                            <!-- Sin datos -->
                            <tr *ngIf="items?.length === 0">
                                <td colspan="7" class="text-center text-muted py-4">
                                    <i class="fas fa-info-circle fa-2x mb-2"></i><br>
                                    No se encontraron ventas/entregas con los filtros aplicados.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Resumen rápido de totales (opcional pero muy útil) -->
                <div class="p-3 bg-light border-top" *ngIf="items?.length > 0">
                    <div class="row text-center">
                        <div class="col-md-4">
                            <small class="text-muted d-block">Total Vendido</small>
                            <h5 class="text-success mb-0">
                                {{ totalVendido | currency:'$ ' }}
                            </h5>
                        </div>
                        <div class="col-md-4">
                            <small class="text-muted d-block">Total Ganancia</small>
                            <h5 class="text-primary mb-0">
                                {{ totalGanancia | currency:'$ ' }}
                            </h5>
                        </div>
                        <div class="col-md-4">
                            <small class="text-muted d-block">Registros</small>
                            <h5 class="mb-0">{{ items.length }}</h5>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Footer + botón Excel -->
        <div class="card-footer bg-light d-flex justify-content-between align-items-center">
            <button type="button" (click)="exportTableToExcel('tblData','ventas-por-detalle')"
                class="btn btn-outline-success">
                <i class="fas fa-file-excel me-2"></i> Generar Excel
            </button>

            <small class="text-muted">
                Generado el {{ fecha | date:'dd-MM-yyyy HH:mm' }}
            </small>
        </div>
    </div>
</div>